import React, { useState } from 'react';
import { useObservable } from 'react-use-observable';

import { Tabs } from 'antd';

import TopPage from 'v2/components/Shared/TopPage';
import { InterruptionTabs } from 'v2/interfaces/reports/interruption';
import { cancelService, initialFilter as cancelInitialFilter } from 'v2/services/reports/cancel';
import { suspendService, initialFilter as suspendInitialFilter } from 'v2/services/reports/suspend';

import * as Cancel from './Cancel';
import * as Suspend from './Suspend';

function InterruptionReport() {
  const [tab, setTab] = useState<string>(InterruptionTabs.CANCEL);
  useObservable(() => {
    if (tab === InterruptionTabs.CANCEL) {
      cancelService.setFilter(cancelInitialFilter);
      return cancelService.loadData(InterruptionTabs.CANCEL);
    }

    suspendService.setFilter(suspendInitialFilter);
    return suspendService.loadData();
  }, [tab]);

  const handleChange = (newTab: string) => setTab(newTab);

  return (
    <>
      <TopPage
        title='Motivos de Cancelamento e Suspensão'
        extra='Saiba porque seus contratos têm sido cancelados ou suspensos.'
        disableAlerts
      />

      <Tabs
        className='mb-4'
        activeKey={tab}
        onChange={handleChange}
        items={[
          { key: InterruptionTabs.CANCEL, label: 'Cancelamentos' },
          { key: InterruptionTabs.SUSPEND, label: 'Suspensões' }
        ]}
      />

      {tab === InterruptionTabs.CANCEL ? <Cancel.Filter /> : <Suspend.Filter />}
      {tab === InterruptionTabs.CANCEL ? <Cancel.ChartTab /> : <Suspend.ChartTab />}
    </>
  );
}

export default InterruptionReport;
